var l={SMALL:"small",MEDIUM:"medium",LARGE:"large"},e={small:16,medium:20,large:24},m={LEFT:"left",RIGHT:"right"};export{m as IconPosition,l as IconSize,e as MappedIconSize};
//# sourceMappingURL=types.js.map
